import React from 'react';
import {injectIntl, intlShape} from 'react-intl';
import ContactsList from './ContactsList';
import ContactAvatar from './ContactAvatar';
import {inject, observer} from "mobx-react";

@inject('contactsStore') @observer
class NewGroupSelectedParticipants extends React.Component{
  
    render(){
        const {selection, onRemoveContactClick, intl} = this.props;
        
        if( selection.length > 0 ){
            return <Selection 
                        selection={selection} 
                        onRemoveContactClick={onRemoveContactClick} />;
        }
        else{
            return null;
        }
    }
}

@inject('contactsStore') @observer
class Selection extends React.Component{
    
    render(){
        const {contactsStore, selection, onRemoveContactClick} = this.props;
        return(
            <div className="new-group-selected-participants">
              { contactsStore.getParticipantsInSelection(selection).map(
                (item) =>
                  <ContactAvatar 
                    contact={item}
                    showName={true}
                    onRemoveClick={onRemoveContactClick}
                    key={item.id}
                  />
              )}
            </div>
        );    
    }
};

export default injectIntl(NewGroupSelectedParticipants);